
app.commonController = app.commonController || {};
app.commonController.defaultAction = {
   
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        
        // Touch detection
        if (!('ontouchstart' in document.documentElement)) {
            $('html').removeClass('touch').addClass('no-touch');
        }
        else {
            $('html').removeClass('no-touch').addClass('touch');
        }

        document.addEventListener('touchmove', function (e) {
            if ($('body').hasClass('no-scroll') && $(document).width() < 640) {
                e.preventDefault();
            }

            var targetElement = event.target || event.srcElement;
            // console.log(targetElement);

            if (targetElement.className.split(" ").indexOf("overlay") >= 0) {
                e.preventDefault();
            }
        });


        // Enable transition after DOM is loaded
        $(document).ready(function(){
            $("body").removeClass("preload");
        });

        // Object-fit polyfill
        $(function () { objectFitImages(); });


        // if(!navigator.userAgent.match('Macintosh')){
        //     // Apply slim scroll plugin
        //     var one = new slimScroll($('.mainNavMenu'), {
        //         'wrapperClass': 'scroll-wrapper unselectable mac',
        //         'scrollBarContainerClass': 'scrollBarContainer',
        //         'scrollBarContainerSpecialClass': 'animate',
        //         'scrollBarClass': 'scroll',
        //         'keepFocus': true
        //     });
        //
        //     // resize example
        //     // To make the resizing work, set the height of the container in PERCENTAGE
        //     window.onresize = function(){
        //         one.resetValues();
        //     }
        // }

        // Back to top link
        this.backToTop();

        this.scrollTo();
    },
    
    backToTop : function () {
        var $topLink = $('.backToTop');
        if ($topLink.length > 0) {
            
            var scrollOffset = function() { return $(document).scrollTop(); };
            
            $topLink.on('click', function(){
                $('html, body').animate({ scrollTop:0 }, 500);
            });
            
            $(document).on('scroll', function() {
                if (scrollOffset() > $(window).innerHeight() /2 ) {
                    $('body').addClass('active-backToTop');
                }
                else {
                    $('body').removeClass('active-backToTop');
                }
            });
        }
    },

    scrollTo : function () {
        $('.js-scrollTo').on('click', function() {
            var page = $(this).attr('href');
            var speed = 750;
            $('html, body').animate( { scrollTop: $(page).offset().top }, speed );
            return false;
        });
    },
        
};

$(document).ready(function(){
    app.commonController.defaultAction.init();
});
